
import Style from "./style"

import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

const QuestionList = ({ questionList }) => {

    return (
        <Style.Wrapper>
            {questionList?.map((elem, index) =>
                <Style.Problem>
                    <h2><span>Q{index + 1}</span>{elem?.problem}</h2>
                    <h2><span>배점</span>{elem?.point}</h2>
                    <Style.ChoiceDiv>
                        {elem?.choice?.map((choice, choiceIndex) =>
                            <Style.Choice>
                                <img src={elem.answer === choiceIndex ? checked : check} />
                                <p>{choice}</p>
                            </Style.Choice>
                        )}
                    </Style.ChoiceDiv>
                </Style.Problem>
            )}
        </Style.Wrapper>
    )
}

export default QuestionList